import Vue from 'vue'
import Vuex from 'vuex'
import canvasModule from '@/store/modules/canvas/canvasModule'
import authModule from '@/store/modules/auth/auth'
import utilModule from '@/store/modules/utils/utils'
import challengeModule from '@/store/modules/challenge/challenge'
import organizationModule from '@/store/modules/organization/organization'
import eventModule from '@/store/modules/event/event'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // UI states
    fontSize: 12,
    tabs: {

      whiteboard: {
        thoughtCatcherTab:
        {
          icon: 'mdi-cloud',
          text: 'Thought Catcher',
          isActive: false,
          badgeNumber: 0
        },
        participantsTab:
        {
          icon: 'mdi-account',
          text: 'Participants',
          isActive: false,
          badgeNumber: 0
        },
        parkingLotTab:
        {
          icon: 'mdi-car-info',
          text: 'Parking Lot',
          isActive: false,
          badgeNumber: 0
        },
        factsTab: {
          icon: 'mdi-head-flash',
          text: 'Facts',
          isActive: false,
          badgeNumber: 0
        },
        helpTab:
        {
          icon: 'mdi-help-circle',
          text: 'Help',
          isActive: false
        }
      },

      admin: {
        challengesTab: {
          icon: 'mdi-animation',
          text: 'Challenges',
          isActive: false,
          to: '/admin-dashboard/active-challenges',
          privileged: false
        },
        archivedChallengesTab: {
          icon: 'mdi-package-down',
          text: 'Archived Challenges',
          isActive: false,
          to: '/admin-dashboard/archived-challenges',
          privileged: false
        },
        globalChallengesTab: {
          icon: 'mdi-earth',
          text: 'Global Challenges',
          isActive: false,
          to: '/admin-dashboard/global-active-challenges',
          privileged: true
        },
        globalArchivedChallengesTab: {
          icon: 'mdi-earth-remove',
          text: 'Archived Global Challenges',
          isActive: false,
          to: '/admin-dashboard/global-archived-challenges',
          privileged: true
        }
        // organizationTab:
        // {
        //   icon: 'mdi-domain',
        //   text: 'Organizations',
        //   isActive: false,
        //   to: '/admin-dashboard/organizations'
        // },
        // usersTab:
        // {
        //   icon: 'mdi-account',
        //   text: 'Users',
        //   isActive: false,
        //   to: '/admin-dashboard/users'
        // }
      },

      user: {
        challengesTab:
        {
          icon: 'mdi-animation',
          text: 'Challenges',
          isActive: false,
          to: '/user-dashboard/challenges'
        }
      }
    }
  },

  mutations: {
    // UI mutations
    setFontSize (state, payload) {
      state.fontSize = payload
    },

    setTab (state, { drawerName, tabName }) {
      // hide all tabs other than the one being activated
      for (var t in state.tabs[drawerName]) {
        if (t !== tabName) {
          state.tabs[drawerName][t].isActive = false
        }
      }
      state.tabs[drawerName][tabName].isActive = !state.tabs[drawerName][tabName].isActive

      // notifications become 0, if tab was opened
      if (
        state.tabs[drawerName][tabName].isActive &&
        tabName !== 'participantsTab' &&
        state.tabs[drawerName][tabName].badgeNumber !== undefined
      ) {
        state.tabs[drawerName][tabName].badgeNumber = 0
      }
    },

    setTabBadgeNumber (state, { drawerName, tabName, badgeNumber }) {
      state.tabs[drawerName][tabName].badgeNumber = badgeNumber
    },

    setDrawer (state, payload) {
      state.drawer = payload
    }
  },
  actions: {},
  modules: {
    canvas: canvasModule,
    auth: authModule,
    util: utilModule,
    challenge: challengeModule,
    organization: organizationModule,
    event: eventModule
  }
})
